import styled from 'styled-components'

export const RecommendationOptions = styled.div`
  margin-bottom: 0;
  padding: 0;
`;
